import React, { useState, useEffect } from "react";
import api from "../services/api";
import { useParams } from "react-router-dom";
import { formatarValor } from "./OrderTable";

const OrderSimulationTable = ({ transporte, outrosCustos, dollarInFloat }) => {
  const { id } = useParams();
  const [orderLoadItems, setOrderLoadItems] = useState([]);

  useEffect(() => {
    const fetchOrdersItems = async () => {
      try {
        const response = await api.get(`/order-load-items/order/id/${id}`);
        setOrderLoadItems(response.data);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrdersItems();
  }, []);

  const volumeTotal = orderLoadItems.reduce((acc, item) => acc + item.size, 0);

  const valorTotalItems = orderLoadItems.reduce(
    (total, item) => total + item.target_value * item.quantity,
    0
  );

  console.log("valor total itens: ", valorTotalItems);

  return (
    <div className="bg-[#F2F2F2] rounded-md px-4 pb-4 pt-8 mt-4 text-boldGray opacity-90">
      <div className="overflow-x-auto max-w-[1560px] custom-scrollbar">
        <table className="w-full table-auto border-collapse custom-scrollbar">
          <thead>
            <tr className="uppercase bold text-base">
              <th className=" p-4 col-span-2">Item</th>
              <th className=" p-4 col-span-2">Quantidade</th>
              <th className=" p-4 col-span-1">Valor alvo</th>
              <th className=" p-4 col-span-1">Valor un.</th>
              <th className=" p-4 col-span-1">Impostos</th>
              <th className=" p-4 col-span-1">Transporte</th>
              <th className=" p-4 col-span-1">Outros custos</th>

              <th className=" p-4 col-span-1">Custo Un. alvo</th>
              <th className=" p-4 col-span-1">Custo Un.</th>
            </tr>
          </thead>
          <tbody className="space-y-4">
            {orderLoadItems.map((orderLoadItem, index) => {
              const totalImposto =
                (orderLoadItem.ii_value +
                  orderLoadItem.ipi_value +
                  orderLoadItem.pis_value +
                  orderLoadItem.cofins_value +
                  orderLoadItem.icms_value) *
                dollarInFloat;

              const outrosCustosPorItem =
                ((orderLoadItem.quantity * orderLoadItem.target_value) /
                  valorTotalItems) *
                outrosCustos;

              const valorTransportePorItem =
                (orderLoadItem.size / volumeTotal) * transporte;
              return (
                <React.Fragment key={index}>
                  <tr className="text-center bg-[#E7E7E7] w-full h-[80px]">
                    <td className=" py-4 col-span-2">
                      <div className="line-clamp-2">{orderLoadItem.name}</div>
                    </td>
                    <td className=" py-4 col-span-2">
                      <div className="line-clamp-2">
                        {orderLoadItem.quantity}
                      </div>
                    </td>
                    <td className=" py-4 col-span-1">
                      {" "}
                      {formatarValor(
                        orderLoadItem.target_value *
                          orderLoadItem.average_dollar_cost,
                        "BRL"
                      )}
                    </td>
                    <td className=" py-4 col-span-1">
                      {" "}
                      {formatarValor(
                        orderLoadItem.unit_value *
                          orderLoadItem.average_dollar_cost,
                        "BRL"
                      )}
                    </td>
                    <td className=" py-4 col-span-1">
                      {" "}
                      {formatarValor(
                        totalImposto / orderLoadItem.quantity,
                        "BRL"
                      )}
                    </td>
                    <td className=" py-4 col-span-1">
                      {formatarValor(
                        valorTransportePorItem / orderLoadItem.quantity,
                        "BRL"
                      )}
                    </td>
                    <td className=" py-4 col-span-1">
                      {formatarValor(
                        outrosCustosPorItem / orderLoadItem.quantity,
                        "BRL"
                      )}
                    </td>

                    <td className=" py-4 col-span-1">
                      {formatarValor(
                        orderLoadItem.target_value *
                          orderLoadItem.average_dollar_cost +
                          (totalImposto +
                            valorTransportePorItem +
                            outrosCustosPorItem) /
                            orderLoadItem.quantity,
                        "BRL"
                      )}
                    </td>
                    <td className=" py-4 col-span-1">
                      {" "}
                      {formatarValor(
                        orderLoadItem.unit_value *
                          orderLoadItem.average_dollar_cost +
                          (totalImposto +
                            valorTransportePorItem +
                            outrosCustosPorItem) /
                            orderLoadItem.quantity,
                        "BRL"
                      )}
                    </td>
                  </tr>
                  {index !== orderLoadItems.length - 1 && (
                    <tr>
                      <td className="h-[6px]"></td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderSimulationTable;
